export const getTitle = (titles?: ILegalDocumentTitle[], currentLang?: string) => {
  return titles?.find(t => t.lang === currentLang)?.title ?? titles?.find((t) => t?.lang === 'ru')?.title ?? '';
}

export const getText = (texts?: ILegalDocumentText[], currentLang?: string) => {
  return texts?.find(t => t.lang === currentLang)?.text ?? texts?.find((t) => t?.lang === 'ru')?.text ?? '';
}export const getTitle = (titles?: ILegalDocumentTitle[], currentLang?: string) => {
  return titles?.find(t => t.lang === currentLang)?.title ?? titles?.find((t) => t?.lang === 'ru')?.title ?? '';
}

export const getText = (texts?: ILegalDocumentText[], currentLang?: string) => {
  return texts?.find(t => t.lang === currentLang)?.text ?? texts?.find((t) => t?.lang === 'ru')?.text ?? '';
}